var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.32178,
    height: 147.32178,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 147.32178 147.32178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3280.28047,
    y1: -718.16209,
    x2: -3302.29129,
    y2: -718.16209,
    gradientTransform: "translate(759.55951 -3243.83667) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -653.71342,
    y2: -653.71342,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3298.84743,
    y1: -685.94005,
    x2: -3312.06988,
    y2: -685.94005,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 147.32178,
    height: 147.32178,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v7858lc3pd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.49239,81.69453c0-.04604-.04604-.09208-.04604-.13812-.09872-.33776-.23784-.66237-.41434-.96679-.04604-.09208-.09208-.13812-.13812-.18416-.18416-.27623-.3683-.55246-.59849-.73661-.09208-.13812-.23019-.23019-.3683-.32226-.18416-.13812-.3683-.32226-.55246-.41434,0-.04604-.04604-.04604-.04604-.04604l-29.8787-17.08012v-29.57945l-9.20761,3.84418v25.73527l-23.01903,13.16688v-25.82735h-9.20761v25.82735l-22.97299-13.16688v-26.08056l-9.20761-3.49889v29.57945l-29.92474,17.08012v.04604h-.04604c-.18415.09208-.3683.27623-.55246.41434-.09208.09208-.27623.18416-.3683.32226-.23019.18416-.41434.46038-.59849.73661-.04604.04604-.09208.09208-.13811.18416-.18415.32226-.27623.64453-.41434.96679,0,.04604-.04604.09208-.04604.13812-.09208.3683-.13811.78265-.13811,1.19699v36.87648c0,1.65737.87472,3.17663,2.3019,4.00531l32.22664,18.41522c.23019.13812.46038.23019.73661.32226.13811.04604.23019.09208.3683.13812.77116.18961,1.57678.18961,2.34794,0,.09208-.04604.23019-.09208.32226-.13812.27623-.09208.55246-.18416.78265-.32226l29.92474-17.12615,29.92474,17.12615c.23019.13812.50642.23019.78265.32226.09208.04604.23019.09208.32226.13812.78758.18229,1.6064.18229,2.39398,0,.09208-.04604.23019-.09208.32226-.13812.27623-.09208.50642-.18416.78265-.32226l32.1806-18.41522c1.42718-.82869,2.34794-2.34794,2.34794-4.00531v-36.87648c0-.41434-.09208-.82869-.18415-1.19699ZM36.78902,130.26469l-22.97299-13.16689v-26.24169l22.97299,13.16689v26.24169ZM41.39282,96.01237l-22.92695-13.12085,22.92695-13.12085,22.92695,13.12085-22.92695,13.12085ZM69.01565,117.0978l-23.01903,13.16689v-26.24169l23.01903-13.16689v26.24169ZM101.24229,130.26469l-23.01903-13.16689v-26.24169l23.01903,13.16689v26.24169ZM105.8461,96.01237l-22.92695-13.12085,22.92695-13.12085,22.92695,13.12085-22.92695,13.12085ZM133.46893,117.0978l-23.01903,13.16689v-26.24169l23.01903-13.16689v26.24169Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.18981,59.8863v-23.01903h18.41522v23.01903h-18.41522Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.18981,18.45205h18.41522v19.42345h-18.41522v-19.42345Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63848,59.8863v-23.01903h18.41522v23.01903h-18.41522Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63848,18.45205h18.41522v19.42345h-18.41522v-19.42345Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.41184,69.09391v-13.82523h18.41523v13.82523h-18.41523Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.41184,35.84523h18.41523v19.42345h-18.41522v-19.42345Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 73.66089,
    x2: 147.32178,
    y2: 73.66089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 36.81384,
    y1: 27.31005,
    x2: 110.44803,
    y2: 27.31005,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h147.32178v147.32178H0V0Z",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.63327,50.34519c-.80263.00035-1.59141-.20914-2.28809-.6077l-32.21283-18.42903c-2.20699-1.26257-2.97259-4.0752-1.71002-6.28219.40744-.71221.99781-1.30258,1.71002-1.71002L71.34517,4.88261c1.42258-.81027,3.15821-.81027,4.57618,0l32.21283,18.43364c2.20699,1.26768,2.96845,4.08446,1.70076,6.29145-.40637.70748-.99328,1.29439-1.70076,1.70076l-32.21283,18.42903c-.69668.39856-1.48546.60805-2.28809.6077ZM50.69251,27.31235l22.94076,13.12545,22.94077-13.12545-22.94076-13.13005s-22.94076,13.13005-22.94077,13.13005Z",
    fill: "url(#linear-gradient-5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelSwitcher);
export default __webpack_public_path__ + "static/media/model_switcher.e077a192c2d30b01da4d11566a4d1904.svg";
export { ForwardRef as ReactComponent };